import React from "react";
import menu_status from "../assets/img/icon_menu_status.svg";
import menu_point from "../assets/img/icon_menu_point.svg";
import menu_calendar from "../assets/img/icon_menu_calendar.svg";
import menu_pay from "../assets/img/icon_menu_pay.svg";
import menu_user from "../assets/img/icon_menu_user.svg";
import menu_account from "../assets/img/icon_menu_account.svg";
import menu_products from "../assets/img/icon_menu_products.svg";
import menu_contact from "../assets/img/icon_menu_contact.svg";

const Mypage = () => {
  return (
    <section className="section menu-section">
      <nav className="menu-nav">
        <ul className="flex middle between wrap">
          <li>
            <a href="/order">
              <i>
                <img src={menu_status} alt="" />
              </i>
              ご注文状況
            </a>
          </li>
          <li>
            <a href="/point">
              <i>
                <img src={menu_point} alt="" />
              </i>
              ポイント履歴
            </a>
          </li>
          <li>
            <a href="/regular">
              <i>
                <img src={menu_calendar} alt="" />
              </i>
              定期内容
            </a>
          </li>
          <li>
            <a href="/cardinfo">
              <i>
                <img src={menu_pay} alt="" />
              </i>
              クレジットカード<br />登録情報
            </a>
          </li>
          <li>
            <a href="/products">
              <i>
                <img src={menu_products} alt="" />
              </i>
              商品一覧
            </a>
          </li>
          <li>
            <a href="/contact">
              <i>
                <img src={menu_contact} alt="" />
              </i>
              お問い合わせ
            </a>
          </li>
          <li>
            <a href="/userinfo">
              <i>
                <img src={menu_user} alt="" />
              </i>
              お客様情報
            </a>
          </li>
          <li>
            <a href="/account">
              <i>
                <img src={menu_account} alt="" />
              </i>
              アカウント管理
            </a>
          </li>
        </ul>
      </nav>
    </section>
  );
};

export default Mypage;
